module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/app-download/ico_app.png";